<template>
	<article class="view-privacy">
		<div class="site-wrapper rythm-v">
			<header>
				<h1>Politique de confidentialité</h1>
			</header>
			<section>
				<h2>Objet du traitement (finalité et base légale)</h2>

				<p>CrossDoc traite vos données personnelles lors :</p>

				<ul>
					<li>item</li>
					<li>item</li>
					<li>item</li>
					<li>item</li>
				</ul>
			</section>
		</div>
	</article>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
	name: "Privacy",

	data: function() {
		return {};
	}
};
</script>
